import { Carrier, Port, Route, Vessel } from './../';
import { Leg } from './leg';

export class Trip {
  // from json
  public duration: number;
  public legs: Array<Leg>;
  public carrier: Carrier;

  // for display
  public departureDate: string;
  public departurePort: Port;

  public arrivalDate: string;
  public arrivalPort: Port;

  public viewDetails: boolean;
  public transhipments: string;
  public durationText: string;

  public portStops: Array<PortStop>;

  constructor(json: any) {
    this.duration = json.duration || 0;
    this.carrier = new Carrier(json.carrier);
    this.legs = [];
    for (let current = 0; current < json.legs.length; current++) {
      this.legs.push(new Leg(json.legs[current]));
    }

    this.viewDetails = false;
    this.departureDate = this.legs[0].startDate;
    this.departurePort = this.legs[0].startPort;

    this.durationText = this.duration == 1 ? '1 day' : `${this.duration} days`;

    if (json.legs.length === 1) {
      this.transhipments = 'direct';
      this.arrivalDate = this.legs[0].endDate;
      this.arrivalPort = this.legs[0].endPort;
    } else {
      this.transhipments = (this.legs.length - 1).toString() + ' t/s';
      this.arrivalDate = this.legs[this.legs.length - 1].endDate;
      this.arrivalPort = this.legs[this.legs.length - 1].endPort;
    }
  }

  getPortStops(): Array<PortStop> {
    if (this.portStops != null) {
      return this.portStops;
    }

    let map = new Map<number, PortStop>();

    for (let current = 0; current < this.legs.length; current++) {
      let startPort = this.legs[current].startPort;
      let startDate = this.legs[current].startDate;
      let endPort = this.legs[current].endPort;
      let endDate = this.legs[current].endDate;

      if (!map.has(startPort.id)) {
        map.set(startPort.id, new PortStop(startDate, startPort));
      }
      if (!map.has(endPort.id)) {
        map.set(endPort.id, new PortStop(endDate, endPort));
      }
    }

    this.portStops = Array.from(map.values());

    return this.portStops;
  }
}

class PortStop {
  public date: string;
  public port: Port;

  public linkParameters: { date: string, scroll: boolean };

  constructor(date:string, port: Port) {
    this.date = date;
    this.port = port;

    this.linkParameters = { date: this.date, scroll: true };
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/models/trip-models/trip.ts